import { Button, Col, Row } from 'antd';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Sidebar } from '../../../shared/components/AppLayout/Sidebar';
import { SideDrawer } from '../../../shared/components/SideDrawer/SideDrawer';
import { D2RsubSectionsMap, defaultScreenForRole, ISidebarTabs, sidebarUtilD2r } from './constant';
import { getD2RSubPageMapper } from './utils';
import { DownloadOutlined } from '@ant-design/icons';
import { envs } from '../../../shared/utils/env';
import { getCompanies } from '../../../shared/api/lightning';
import { AutoCompleteInput } from '../../../shared/components/AutoCompleteInput.js/AutoCompleteInput';
import { AuthContext } from '../../../shared/contexts/Auth';

const { omsBaseUrl } = envs;
export const d2rRoute = '/admin/d2r';
export type companyType = { id: string | null; name: string | null };
const defaultCompany = '{ "id": null, "name":null }';

export const D2r = () => {
	const {
		authState: { profile }
	} = useContext(AuthContext);
	const [sidebarMenuItem, setSidebarMenuItem] = useState(defaultScreenForRole(profile?.user_role)); // Default Tab To show
	const storedCompanyData = () => localStorage.getItem('ADMIN_CATALOGUE_CLICKED');
	const [company, setCompany] = useState<companyType>(JSON.parse(storedCompanyData() ?? defaultCompany));

	const handleDownloadSalesmens = () => {
		const url = new URL(`${omsBaseUrl}/csv/d2r/salesmen`);
		window.open(url);
	};

	const D2R_SUB_PAGE_MAPPER = useMemo(() => getD2RSubPageMapper(company), [company]);
	const showCompanySearchWhereIndexes = [
		D2RsubSectionsMap[ISidebarTabs.RETAIL_DISCOUNT],
		D2RsubSectionsMap[ISidebarTabs.BEATS],
		D2RsubSectionsMap[ISidebarTabs.INVOICES]
	];

	useEffect(() => {
		localStorage.setItem('ADMIN_CATALOGUE_CLICKED', JSON.stringify(company));
	}, [company]);

	return (
		<Row className="h-100 p-0">
			<SideDrawer placement="left">
				<Sidebar
					selectedMenu={sidebarMenuItem}
					sideBarMenu={sidebarUtilD2r(profile?.user_role).sideBar}
					onMenuItemSelect={setSidebarMenuItem}
					topComponent={
						showCompanySearchWhereIndexes.includes(sidebarMenuItem) ? (
							<AutoCompleteInput
								getOptions={getCompanies}
								entityName="companies"
								selectedFilterItems={{ entityId: company?.id, name: company?.name }}
								responseFieldPath="companies"
								optionKeyPath="entityId"
								optionLabelPath="name"
								optionValuePath="entityId"
								placeholder="Search company"
								handleSelect={(option: any) => setCompany({ id: option?.entityId, name: option?.name })}
							/>
						) : null
					}
					bottomButtons={
						sidebarMenuItem === D2RsubSectionsMap[ISidebarTabs.RETAIL_DISCOUNT] ? (
							<Button icon={<DownloadOutlined />} type="primary" size="large" onClick={() => handleDownloadSalesmens()}>
								Download Salesmen Data
							</Button>
						) : null
					}
				/>
			</SideDrawer>
			<Col sm={24} lg={20} className={`scrollable`}>
				{D2R_SUB_PAGE_MAPPER[sidebarMenuItem]}
			</Col>
		</Row>
	);
};
